import cx from 'classnames';
import type { ComponentProps } from 'react';

import Spinner from 'components/Spinner/Spinner';

type CenteredSpinnerProps = ComponentProps<typeof Spinner>;

const CenteredSpinner = ({ className, variant = 'gray80', size = 'xs', ...spinnerProps }: CenteredSpinnerProps) => (
  <div className={cx('flex h-full w-full items-center justify-center', className)}>
    <Spinner variant={variant} size={size} {...spinnerProps} />
  </div>
);

export default CenteredSpinner;
